import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { updateUser } from '../../../slices/userSlice';
import { useDispatch } from 'react-redux';
import { getUser } from '../../../services/authService';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToPageHandler = async () => {
    const user = await getUser();
    if (user) {
      dispatch(updateUser({ isLoggedIn: true, userId: user.id, email: user.email }));
      navigate('/');
    } else {
      navigate(`/login`);
    }
  };

  return (
    <Box textAlign="center" py={10} px={2}>
      <Typography variant="h3" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button variant="outlined" onClick={goToPageHandler}>
        Go to Homepage
      </Button>
    </Box>
  );
};

export default NotFoundPage;
